module.exports = __webpack_public_path__ + "img/cuhkszlogo.ba98f12c.png";